import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';
import { Enum } from '../enums';

export const getCustomEmployeeFieldTranslations = (
  strLangs: string[],
  includeInactive = false,
): Promise<Enum[][]> => {
  return Promise.all(
    strLangs.map((strLang) =>
      fetchFromOldApi(
        `/json/enum/CUSTOM_ENTITY_EMPLOYEE/${strLang}?includeInactive=${includeInactive}`,
      ).then((r) => r.json()),
    ),
  );
};

export const useCustomFieldTranslations = (
  strLangs: string[],
  includeInactive = false,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  const { data, isLoading, error } = useArraySWR<Enum[]>(
    !isDisabled && isCustomDataEnabled
      ? ['getCustomEmployeeFieldTranslations']
      : null,
    () => getCustomEmployeeFieldTranslations(strLangs, includeInactive),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
